import { isEmpty } from "lodash";
import React from "react";
import { getFormattedDateFromInterval } from "../../../../../util/getFormattedDateFromInterval";
import { useUpdateEventSearchFilters } from "../../../../hooks/event-search-filters/useUpdateEventSearchFilters";
import { isDefaultTimeRange } from "../util/isDefaultTimeRange";
import { BaseChip } from "./BaseChip";
export const TimeRangeFilters = ({
  included,
  excluded,
  eventSearchBlockId,
  conversationId,
  disabled = false,
}: {
  included: string[];
  excluded: string[];
  eventSearchBlockId: string;
  conversationId: string;
  disabled?: boolean;
}) => {
  // Is view only if the time range is today through next friday (default BE search range)
  const isInlcudedViewOnly = included.length === 1 && isDefaultTimeRange(included[0]);
  const { updateTimeRangeFilter } = useUpdateEventSearchFilters();

  if (isEmpty(included) && isEmpty(excluded)) {
    return null;
  }

  const onDelete = (type: "included" | "excluded") => () => {
    updateTimeRangeFilter(eventSearchBlockId, conversationId, type, []);
  };

  const includedTimesString = included.map((time) => getFormattedDateFromInterval(time)).join(", ");
  const excludedTimeString = excluded.map((time) => getFormattedDateFromInterval(time)).join(", ");
  const excludedComponent = (
    <>
      <span className="cw-text-subtle">Not</span> {excludedTimeString}
    </>
  );

  return (
    <>
      {!isEmpty(included) && (
        <BaseChip
          disabled={disabled}
          onDelete={isInlcudedViewOnly ? undefined : onDelete("included")}
        >
          {includedTimesString}
        </BaseChip>
      )}
      {!isEmpty(excluded) && (
        <BaseChip disabled={disabled} onDelete={onDelete("excluded")}>
          {excludedComponent}
        </BaseChip>
      )}
    </>
  );
};
